import { useState, useEffect, useMemo } from 'react';
import { getCheckoutAoeQuestions, getMissingRequiredAoe } from '../services/aoeNormalizer';

/**
 * Owns AOE ("Ask on Order Entry") answer state and derived question sets for
 * the dedicated lab-questions step. Selects the right questions for single vs
 * combined panels and prefills Junction defaults.
 */
export default function useLabCheckoutAoe(lab, selectedMethod) {
  const [aoeAnswers, setAoeAnswers] = useState({});

  const checkoutAoeQuestions = useMemo(
    () => getCheckoutAoeQuestions(lab, selectedMethod),
    [lab, selectedMethod],
  );

  const missingAoeQuestions = useMemo(
    () => getMissingRequiredAoe(checkoutAoeQuestions, aoeAnswers),
    [checkoutAoeQuestions, aoeAnswers],
  );

  // Prefill any AOE question that carries a Junction default and has no answer.
  useEffect(() => {
    if (!checkoutAoeQuestions.length) return;
    setAoeAnswers((prev) => {
      let changed = false;
      const next = { ...prev };
      checkoutAoeQuestions.forEach((q) => {
        const key = `${q.markerId}:${q.questionId}`;
        const hasDefault = q.defaultValue != null && q.defaultValue !== '';
        if (hasDefault && (next[key] == null || next[key] === '')) {
          next[key] = String(q.defaultValue);
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [checkoutAoeQuestions]);

  return { aoeAnswers, setAoeAnswers, checkoutAoeQuestions, missingAoeQuestions };
}
